export const ciclesTypes = [
  { value: "TETRA_SEMANAL", label: "Tetra Semanal" },
  { value: "TETRA_OPCIONAL", label: "Tetra Opcional" },
  { value: "DIARIO", label: "Diário Simples" },
  { value: "TRI_DIARIO", label: "Tri Diário" },
  { value: "BI_DIARIO", label: "Bi Diário" },
  { value: "TRI_SEMANAL", label: "Tri Semanal" },
  { value: "BI_SEMANAL", label: "Bi Semanal" },
];

export const periods = [
  { value: "PONTA", label: "Ponta" },
  { value: "CHEIAS", label: "Cheias" },
  { value: "VAZIO", label: "Vazio" },
  { value: "VAZIO_NORMAL", label: "Vazio normal" },
  { value: "SUPER_VAZIO", label: "Super vazio" },
  { value: "FORA_VAZIO", label: "Fora de vazio" },
];

export const periodsForTariffs = [
  { value: "PONTA", label: "Energia nas Horas de Ponta" },
  { value: "CHEIAS", label: "Energia nas Horas de Cheias" },
  { value: "VAZIO_NORMAL", label: "Energia nas Horas de Vazio" },
  { value: "SUPER_VAZIO", label: "Energia nas Horas de Super Vazio" },
  { value: "VENDA_REDE", label: "Venda à Rede (Opcional)" },
];

export const EnergyManagementTypes = [
  { value: "NONE", label: "Desativado" },
  { value: "GDBN_FLEXIBILITY", label: "GDBN + Flexibilidade" },
  { value: "OSTEC_FLEXIBILITY", label: "OSTEC + Flexibilidade " },
  { value: "OSTEC_SIMPLE", label: "OSTEC" },
  { value: "RENEWING", label: "Renewing" },
  { value: "CAPWATT", label: "CapWatt" },
  { value: "HEDGE_IOT", label: "Hedge IoT" },
];

export const CommunityOrAggregatorTypes = [
  { value: "EGAC", label: "EGAC" },
  { value: "AGGREGATOR", label: "Agregador" },
  { value: "EGAC+AGGREGATOR", label: "EGAC + Agregador" },
];

export const contractTypes = [
  { value: "NO_VALUES", label: "Sem Valores" },
  { value: "INDEXED", label: "Indexado (Ks)" },
  { value: "FIXED", label: "Tarifas fixas" },
  { value: "INDEXED_SIMPLIFIED", label: "Indexado (Simples)" },
];

export const ERSETariffsTypes = [
  { value: "ENERGY", label: "Energia Ativa" },
  { value: "POWER", label: "Potência nas Horas de Ponta" },
  { value: "CONTRACTED_POWER", label: "Potência Contratada" },
];

export const resourceTypes = [
  { value: "STORAGE", label: "Bateria" },
  { value: "SCPU", label: "UPAC" },
  { value: "IU", label: "Instalação de Utilização" },
  { value: "IC", label: "Instalação de Consumo" },
  { value: "EV", label: "Veículo Elétrico" },
  { value: "EWH", label: "Termoacumulador" },
  { value: "HP", label: "Bomba de Calor" },
];

export const meterTypes = [
  { value: "CPE", label: "CPE" },
  { value: "INTERNAL", label: "Interno" },
  { value: "AGGREGATOR_METER", label: "Agregador" },
];

export const meterInstallationTypes = [
  { value: "IAC", label: "Instalação de Autoconsumo" },
  { value: "IC", label: "Instalação de Consumo" },
  { value: "IPR", label: "Instalação de Produção" },
  { value: "IA", label: "Instalação de Armazenamento" },
];

export const ALLOCATION_TYPES = [
  { value: "FIXED", label: "Fixos" },
  { value: "PROPORTIONAL", label: "Proporcionais" },
  { value: "DYNAMIC", label: "Dinâmicos" },
];

export const MARKET_RATES = [
  { value: "VANILLA_IMR", label: "Vanilla Intermediate Market Rate" },
  { value: "VANILLA_SDR", label: "Vanilla Supply Demand Ratio" },
  { value: "VANILLA_CV", label: "Vanilla Crossing Value" },
  { value: "BILATERAL_PRICE", label: "Preços Bilaterais" },
  { value: "FIXED_BILATERAL_PRICE", label: "Preços Bilaterais Fixos" },
  { value: "TREE_DNAC", label: "Tree Dynamic AC" },
  { value: "FIXED_TREE_DNAC", label: "Tree Dynamic AC (Preços Bilaterais Fixos)" },
  { value: "FIXED_PRICE", label: "Preço Fixo (Todas as sessões)" },
];

export const userRoles = [
  { value: "ADMIN", label: "Gestor" },
  { value: "MEMBER", label: "Membro" },
];

export const userPermissions = [
  { value: "OPTIMIZATION_MODULE", label: "Otimização" },
  { value: "SIMULATION_MODULE", label: "Simulação" },
  { value: "SIZING_MODULE", label: "Sizing" },
  { value: "PRICING_MODULE", label: "Pricing" },
  { value: "FLEXIBILITY_MODULE", label: "Flexibilidade" },
];

export const SEASONS_TYPES = [
  { value: "verao", label: "Verão" },
  { value: "inverno", label: "Inverno" },
];

export const DAY_TYPE = [
  { value: "util", label: "Útil" },
  { value: "sabado", label: "Sábado" },
  { value: "domingo", label: "Domingo" },
  { value: "todos", label: "Todos os dias" },
];

export const assets = [
  { value: "EWT", label: "EWT" },
  { value: "MOCK", label: "MOCK" },
  { value: "DOT", label: "DOT" },
  { value: "EUR", label: "EUR" },
];

export const voltageLevelTypes = [
  { value: "MAT", label: "MAT" },
  { value: "AT", label: "AT" },
  { value: "MT", label: "MT" },
  { value: "AT/RNT", label: "AT/RNT" },
  { value: "BT", label: "BT" },
  { value: "BTN simples", label: "BTN simples" },
  { value: "BTN bi-horária", label: "BTN bi-horária" },
  { value: "BTN< tri-horária", label: "BTN < tri-horária" },
  { value: "BTN>", label: "BTN> (BTN Superior)" },
  { value: "BTE", label: "BTE" },
];

export const contractedPowerOptions = [
  { value: 1.15, label: "BTN 1.15 kVA" },
  { value: 2.3, label: "BTN 2.3 kVA" },
  { value: 3.45, label: "BTN 3.45 kVA" },
  { value: 4.6, label: "BTN 4.6 kVA" },
  { value: 5.75, label: "BTN 5.75 kVA" },
  { value: 6.9, label: "BTN 6.9 kVA" },
  { value: 10.35, label: "BTN 10.35 kVA" },
  { value: 13.8, label: "BTN 13.8 kVA" },
  { value: 17.25, label: "BTN 17.25 kVA" },
  { value: 20.7, label: "BTN 20.7 kVA" },
  { value: 27.6, label: "BTN 27.6 kVA" },
  { value: 34.5, label: "BTN 34.5 kVA" },
  { value: 41.4, label: "BTN 41.4 kVA" },
];

export const locales = [
  { value: "en", label: "EN 🇬🇧" },
  { value: "pt", label: "PT 🇵🇹" },
  { value: "es", label: "ES 🇪🇸" },
];

export const STATUS_TYPES = [
  { value: "ACTIVE", label: "Ativo" },
  { value: "INACTIVE", label: "Inativo" },
];

export default {
  ciclesTypes,
  periods,
  periodsForTariffs,
  contractTypes,
  ERSETariffsTypes,
  resourceTypes,
  meterTypes,
  meterInstallationTypes,
  ALLOCATION_TYPES,
  userRoles,
  assets,
  voltageLevelTypes,
  contractedPowerOptions,
  STATUS_TYPES,
  SEASONS_TYPES,
  DAY_TYPE,
  locales,
  EnergyManagementTypes,
  CommunityOrAggregatorTypes,
};

export const SIMULATOR_IMPORT_VERSION = "1.0.14";
